import React, { useState } from 'react';

import { TrustpilotReviewsCarousel } from 'Components/reviews/ReviewsCarousel/TrustpilotReviewsCarousel';
import { Content } from 'LegacySBCRA/Content/Content';

import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';

import styles from './FooterReviews.scss';

const FooterReviews = () => {
  const [failedReviewsCarousel, setFailedReviewsCarousel] = useState(false);

  return (
    <RoundedSection>
      <Content
        center
        className={styles.reviews}
        element="section"
        wrapper={{ className: styles.wrapper }}
      >
        <TrustpilotReviewsCarousel
          failedLoad={failedReviewsCarousel}
          setFailedLoad={setFailedReviewsCarousel}
        />
      </Content>
    </RoundedSection>
  );
};

export default FooterReviews;
